import { createSelector } from "reselect";
import { AppState } from "../appState";
import { ETab } from "../../constants";
import { tabPositionSelector } from "./tabSelectors";

// Base selectors

export const overagesFilterFormSelector = (state: AppState) =>
  state.overagesFilterForm;
const myAssignmentsFilterFormState = (state: AppState) =>
  state.myAssignmentsFilterForm;
const exceptionSearchFilterFormState = (state: AppState) =>
  state.exceptionSearchFilterForm;
const shortagesFilterFormState = (state: AppState) => state.shortagesFilterForm;
const damagesFilterFormState = (state: AppState) => state.damagesFilterForm;
const onHandDeliveryFilterFormState = (state: AppState) => state.onHandDeliveryFilterForm;
// Memoized selector to get overages Filter Form
export const misdeliveryFilterFormState = (state: AppState) => state.misdeliveryFilterForm;

// Memoized selector to get  Filter Form based on tab position

export const filterFromSelector = createSelector(
  [
    tabPositionSelector,
    overagesFilterFormSelector,
    myAssignmentsFilterFormState,
    shortagesFilterFormState,
    damagesFilterFormState,
    onHandDeliveryFilterFormState,
    misdeliveryFilterFormState,
    exceptionSearchFilterFormState,
  ],
  (
    tabPosition: ETab,
    overagesFilterForm,
    myAssignmentsFilterForm,
    shortagesFilterForm,
    damagesFilterForm,
    onHandDeliveryFilterForm,
    misdeliveryFilterForm,
    exceptionSearchFilterFormState
  ) => { // NOSONAR
    const filterFormMap = {
      [ETab.overages]: overagesFilterForm,
      [ETab.shortages]: shortagesFilterForm,
      [ETab.damages]: damagesFilterForm,
      [ETab.onHandDelivery]: onHandDeliveryFilterForm,
      [ETab.misdelivery]: misdeliveryFilterForm,
      [ETab.myAssignments]: myAssignmentsFilterForm,
      [ETab.dashboard]: exceptionSearchFilterFormState,
    } as const;
    
    return filterFormMap[tabPosition as keyof typeof filterFormMap] ?? myAssignmentsFilterForm;
    
  }
);

